module.exports = __webpack_public_path__ + "img/sp05.62214198.png";